import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);


export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'module-simple-tabs';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		this.$select_options =  [];

		this.index = -1;

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	//console.log( 'init Tabs' );
    	//-------------------- init menu ------------------------------------------//
    	this.$lis 		= this.$el.find( '.tabs .tab' );
    	this.$lis.each( ( i, el )=>{
    		$(el).attr( 'data-index', i );
    		if ( $(el).hasClass( 'active' ) ){
    			this.index = i;
    		}
    	});


    	//-------------------- init tabs ------------------------------------------//
    	this.$tabs 		= this.$el.find( '.tabs-content .tab' );
    	this.$tabs.each( ( i, el )=>{
    		$(el).attr( 'data-index', i );
    	});

    	this.addEvents( true );

    	this.setIndex( this.index, true );
	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
			this.$lis.on( 'click', (e) => this.onSelectTab(e) );
		}
		else{
			this.$lis.off( 'click', (e) => this.onSelectTab(e) );
		}
	}

	onSelectTab( e ){
		e.preventDefault();

		let $el = $(e.currentTarget), index = $el.attr( 'data-index' );

		//console.log( $el );

		// deselect current index
		if ( this.index !== -1 ){
			this.setIndex( this.index, false );
		}

		// select next index
		this.setIndex( index, true );

 	}



 	setIndex( i, b ){
 		//console.log( 'setIndex' + i + ', b = '  + b );
 		if ( b ){
 			this.$lis.eq( i ).addClass( 'active' );
 			this.$tabs.eq( i ).addClass( 'active' );

 			this.index = i;
 		}
 		else{
 			this.$lis.eq( i ).removeClass( 'active' );
 			this.$tabs.eq( i ).removeClass( 'active' );
 		}
 	}

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
		if ( this.$el.length > 0 ){
    		this.addEvents( false );
    	}
    }

}
